package com.karawek.core.settings.di

import com.karawek.core.platform.PlatformContext
import com.karawek.core.settings.createSuspendSettings
import com.russhwolf.settings.ExperimentalSettingsApi
import com.russhwolf.settings.coroutines.SuspendSettings
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesTo
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@OptIn(ExperimentalSettingsApi::class)
@ContributesTo(AppScope::class)
interface SettingsModule {

    @SingleIn(AppScope::class)
    @Provides
    fun provideSuspendSettings(
        context: PlatformContext,
    ): SuspendSettings = createSuspendSettings(context = context, name = "app_settings")
}
